/* import __COLOCATED_TEMPLATE__ from './step-link.hbs'; */
import { and, reads } from '@ember/object/computed';
import { classNameBindings, classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './step-link.module.scss';

@classic
@classNameBindings(
  'isEnabled::disabled',
  'isCompleted:completed',
  'isDisabledInPreview',
  'isFirst',
  'isLast',
  'isCondensedStep'
)
@classNames(styles.component)
export default class RequestStepsStepLink extends Component {
  @service request;
  @service analytics;
  @service mixpanel;
  @service session;
  @service currentPractice;
  @service intl;
  @service localeManager;

  hasBeenTracked = false;

  @reads('step.canShowCondensedNav') canShowCondensedNav;
  @reads('step.isCondensed') isCondensed;
  @and('canShowCondensedNav', 'isCondensed') isCondensedStep;
  @reads('step.numberLabel') numberLabel;

  @computed('step.condenseKey', 'isCondensedStep', 'currentStep.condenseKey', 'isEnabledLegacy')
  get isEnabled() {
    const { step, currentStep } = this;

    let condensedKeyEnabled = this.isCondensedStep && currentStep?.condenseKey === step.condenseKey;
    return this.isEnabledLegacy || condensedKeyEnabled;
  }

  @computed('isCondensedStep', 'steps.[]', 'step.condenseKey.[]')
  get condensedSiblings() {
    let { steps, step } = this;
    return steps.filterBy('condenseKey', step.condenseKey);
  }

  @computed('condensedSiblings.[]', 'isCondensedStep', 'step')
  get isLast() {
    let { condensedSiblings, isCondensedStep, step } = this;
    if (isCondensedStep) {
      return condensedSiblings.lastObject === step;
    }
    return false;
  }

  @computed('condensedSiblings.[]', 'isCondensedStep', 'step')
  get isFirst() {
    let { condensedSiblings, isCondensedStep, step } = this;
    if (isCondensedStep) {
      return condensedSiblings.firstObject === step;
    }
    return false;
  }

  @computed('currentStep', 'isCondensed', 'steps.[]', 'model', 'step', 'condensedSiblings.[]')
  get isCompleted() {
    let { isCondensedStep, currentStep, model, steps, step, condensedSiblings } = this;
    if (isCondensedStep) {
      let currentActiveStep = currentStep ?? steps.find(step => step.isActive);

      let incompleteStep = condensedSiblings.find(step => {
        return !model.get(step.completedKey);
      });

      if (step.isCompleteInPreview) return true;

      let firstSiblingIndex = condensedSiblings.firstObject.index;
      let condensedSiblingCount = condensedSiblings.length;
      let lastSiblingIndex = firstSiblingIndex + condensedSiblingCount;

      return currentActiveStep?.index > lastSiblingIndex - 1 && !incompleteStep;
    }

    return model.get(step.completedKey);
  }

  get linkText() {
    // WORKAROUND: Using native getter instead of @computed because Classic Ember
    // @computed decorators cannot observe @tracked properties from services.
    // We access localeManager.currentLocale to establish a tracking dependency
    // so this getter recomputes when the locale changes.
    let { canShowCondensedNav, isCompleted, step, channel, intl, localeManager } = this;
    localeManager.currentLocale; // Establish tracking dependency for locale changes
    let { careCoordinatorMode } = channel || {};
    let { condensedTitle, careCoordinatorCompletedTitle, title, completedTitle } = step;

    if (canShowCondensedNav && condensedTitle) {
      return intl.t(condensedTitle);
    }

    if (isCompleted) {
      let titleKey = (careCoordinatorMode && careCoordinatorCompletedTitle) || completedTitle;
      return intl.t(titleKey);
    }

    let titleKey = (careCoordinatorMode && careCoordinatorCompletedTitle) || title;
    return intl.t(titleKey);
  }

  get shouldTrack() {
    return !this.hasBeenTracked && this.currentStep && this.step.route === this.currentStep.route;
  }

  didRender() {
    super.didRender(...arguments);
    if (this.shouldTrack) {
      this.set('hasBeenTracked', true);
    }
  }
}
